declare global {
    interface RouterMeta {
        title: string;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
        feature?:any;
    }
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}
import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login.vue')
};
export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: 'ManageMenu' },
    component: main,
    children: [
        { path: 'home', meta: { title: 'HomePage' }, name: 'home', component: () => import('../views/home/home.vue') },
        { path: 'post/:postId', permission: 'Pages.Users', meta: { title: 'Post' }, name: 'post', component: () => import('../views/contentmenu/posts/edit-post-page.vue') },
        { path: 'card/:cardId', permission: 'Pages.Users', meta: { title: 'Card' }, name: 'card', component: () => import('../views/contentmenu/cards/edit-card-page.vue') },
        { path: 'editgallery/:galleryId', permission: 'Pages.Users',feature: 'Gallery' , meta: { title: 'Gallery' }, name: 'editgallery', component: () => import('../views/mediamanager/edit-gallery.vue') },
        { path: 'editmedia/:mediaId', permission: 'Pages.Users', meta: { title: 'Media' }, name: 'editmedia', component: () => import('../views/mediamanager/edit-media.vue') },
        { path: 'podcast/:podcastId', permission: 'Pages.Users', meta: { title: 'Podcast' }, name: 'podcast', component: () => import('../views/modules/podcasts/edit-podcast-page.vue') },
        { path: 'author/:authorId', permission: 'Pages.Users', feature: 'Authors', meta: { title: 'Author' }, name: 'author', component: () => import('../views/modules/authors/edit-author-page.vue') },
        { path: 'book/:bookId', permission: 'Pages.Users', feature: 'Books' ,meta: { title: 'Book' }, name: 'book', component: () => import('../views/modules/books/edit-book-page.vue') },
        { path: 'category/:categoryId', permission: 'Pages.Users', meta: { title: 'Category' }, name: 'category', component: () => import('../views/contentmenu/categories/edit-category-page.vue') }
    ]
}
export const appRouters: Array<Router> = [
{
    path: '/setting',
    name: 'setting',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: 'md-settings',
    component: main,
    children: [
        { path: 'user', permission: 'Pages.Roles', meta: { title: 'Users' }, name: 'user', component: () => import('../views/setting/user/user.vue') },
        { path: 'role', permission: 'Pages.Roles', meta: { title: 'Roles' }, name: 'role', component: () => import('../views/setting/role/role.vue') },
        { path: 'tenant', permission: 'Pages.Tenants', meta: { title: 'Tenants' }, name: 'tenant', component: () => import('../views/setting/tenant/tenant.vue') }
    ]
},
{
    path: '/contentMenu',
    name: 'contentMenu',
    permission: '',
    meta: { title: 'ContentMenu' },
    icon: 'md-create',
    component: main,
    children: [
        // { path: 'pages', permission: 'Pages.Users', meta: { title: 'Pages' }, name: 'pages', component: () => import('../views/contentmenu/pages/pages.vue') },
        { path: 'mediamanager', permission: 'Pages.Users', meta: { title: 'MediaManager' }, name: 'mediamanager', component: () => import('../views/mediamanager/media-manager.vue') },
        { path: 'posts', permission: 'Pages.Users', meta: { title: 'Posts' }, name: 'posts', component: () => import('../views/contentmenu/posts/posts.vue') },    
        { path: 'cards', permission: 'Pages.Users', feature: 'Cards' ,meta: { title: 'Cards' }, name: 'cards', component: () => import('../views/contentmenu/cards/cards.vue') },
        { path: 'categories', permission: 'Pages.Users', meta: { title: 'Categories' }, name: 'categories', component: () => import('../views/contentmenu/categories/categories.vue') },
        { path: 'authors', permission: 'Pages.Users',feature: 'Authors', meta: { title: 'Authors' }, name: 'authors', component: () => import('../views/modules/authors/authors.vue') },
        { path: 'books', permission: 'Pages.Users',feature: 'Books', meta: { title: 'Books' }, name: 'books', component: () => import('../views/modules/books/books.vue') },
        { path: 'gallery', permission: 'Pages.Users',feature: 'Gallery', meta: { title: 'Gallery' }, name: 'gallery', component: () => import('../views/modules/gallery.vue') },
        { path: 'menu', permission: 'Pages.Users', meta: { title: 'Menu' }, name: 'menu', component: () => import('../views/modules/menu.vue') },
        { path: 'links', permission: 'Pages.Users', meta: { title: 'Linki' }, name: 'links', component: () => import('../views/modules/links.vue') },
    ]
},
{
    path: '/modules',
    name: 'modules',
    permission: '',
    meta: { title: 'Modules' },
    icon: 'md-albums',
    component: main,
    children: [
        { path: 'vfiles', permission: 'Pages.Users',feature: 'VFiles', meta: { title: 'VFiles' }, name: 'vfiles', component: () => import('../views/modules/vfiles.vue') },
        { path: 'podcastsmanager', permission: 'Pages.Users',feature: 'Podcasts', meta: { title: 'PodcastsMenager' }, name: 'podcastsmanager', component: () => import('../views/mediamanager/podcasts-manager.vue') },
        { path: 'podcasts', permission: 'Pages.Users',feature: 'Podcasts', meta: { title: 'Podcasts' }, name: 'podcasts', component: () => import('../views/modules/podcasts/podcasts.vue') },
        { path: 'slider', permission: 'Pages.Users',feature: 'Slider', meta: { title: 'Slider' }, name: 'slider', component: () => import('../views/modules/slider.vue') },
        { path: 'youtube', permission: 'Pages.Users',feature: 'YoutubeVideos', meta: { title: 'YoutubeVideos' }, name: 'youtube', component: () => import('../views/modules/youtube.vue') },     
        { path: 'newsletter', permission: 'Pages.Users',feature: 'Newsletter', meta: { title: 'Newsletter' }, name: 'newsletter', component: () => import('../views/modules/newsletter.vue') },
    ]
}
]
export const routers = [
    loginRouter,
    locking,
    ...appRouters,
    otherRouters
];
